<template>
  <div class="my-container main_section layout_main_section h-full w-full">
    <main>
      <slot />
    </main>
  </div>
</template>

<script>

export default {
  name: 'GuestLayout',
    data() {
      return {
        windowWidth: window.innerWidth,
      };
    },
};
</script>

<style scoped>
.my-container {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
}
main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background: #F5F5F5;
}
</style>
